export default __webpack_public_path__ + "static/marker_active-01b2f297b0979133aaccdbe49763d10e.svg";